// import axios from "axios";

// const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

// // ----------------------------
// // AUTH HELPERS
// // ----------------------------
// const getAuthHeader = () => {
//   const token = localStorage.getItem("token");
//   return token ? { Authorization: `Bearer ${token}` } : {};
// };

// const getAdminAuthHeader = () => {
//   const token = localStorage.getItem("adminToken");
//   return token ? { Authorization: `Bearer ${token}` } : {};
// };

// // ----------------------------
// // API EXPORTS
// // ----------------------------
// export const api = {
//   // ---------------------------------------------------------
//   // USER AUTH (Public)
//   // ---------------------------------------------------------

//   register: (data) => axios.post(`${API_URL}/auth/register`, data),
//   login: (data) => axios.post(`${API_URL}/auth/login`, data),
//   verifyEmail: (token) =>
//     axios.post(`${API_URL}/auth/verify-email?token=${token}`),

//   forgotPassword: (data) =>
//     axios.post(`${API_URL}/auth/forgot-password`, data),
//   resetPassword: (data) =>
//     axios.post(`${API_URL}/auth/reset-password`, data),

//   // ---------------------------------------------------------
//   // USER ACCOUNT
//   // ---------------------------------------------------------
//   getDashboard: () =>
//     axios.get(`${API_URL}/user/dashboard`, {
//       headers: getAuthHeader(),
//     }),

//   updateProfile: (data) =>
//     axios.put(`${API_URL}/user/profile`, data, {
//       headers: getAuthHeader(),
//     }),

//   changePassword: (data) =>
//     axios.post(`${API_URL}/user/change-password`, data, {
//       headers: getAuthHeader(),
//     }),

//   // ---------------------------------------------------------
//   // VISA TYPES
//   // ---------------------------------------------------------
//   getVisaTypes: () => axios.get(`${API_URL}/visa-types`),

//   getAlldropdowns: () => axios.get(`${API_URL}/dropdowns/all`),

//   getVisaTypeDocuments: (visaTypeId) =>
//     axios.get(`${API_URL}/visa-types/${visaTypeId}/documents`),

//   // ---------------------------------------------------------
//   // USER APPLICATIONS
//   // ---------------------------------------------------------
//   createApplication: (data) =>
//     axios.post(`${API_URL}/applications`, data, {
//       headers: getAuthHeader(),
//     }),

//   getApplications: () =>
//     axios.get(`${API_URL}/applications`, {
//       headers: getAuthHeader(),
//     }),

//   getApplication: (id) =>
//     axios.get(`${API_URL}/applications/${id}`, {
//       headers: getAuthHeader(),
//     }),

//   updateApplication: (id, data) =>
//     axios.put(`${API_URL}/applications/${id}`, data, {
//       headers: getAuthHeader(),
//     }),

//   deleteApplication: (id) =>
//     axios.delete(`${API_URL}/applications/${id}`, {
//       headers: getAuthHeader(),
//     }),

//   // ---------------------------------------------------------
//   // DOCUMENT UPLOAD
//   // ---------------------------------------------------------
//   uploadDocument: (formData) =>
//     axios.post(`${API_URL}/documents/upload`, formData, {
//       headers: {
//         ...getAuthHeader(),
//         "Content-Type": "multipart/form-data",
//       },
//     }),

//   deleteDocument: (id) =>
//     axios.delete(`${API_URL}/documents/${id}`, {
//       headers: getAuthHeader(),
//     }),

//   uploadApplicationDocuments: (formData) =>
//     axios.post(
//       `${API_URL}/documents/bulk-upload`,
//       formData,
//       {
//         headers: {
//           ...getAuthHeader(),
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     ),

//   extractAndMapDocuments: (applicationId) =>
//     axios.post(
//       `${API_URL}/documents/extract-and-map?application_id=${applicationId}`,
//       null,
//       {
//         headers: {
//           ...getAuthHeader(),
//         },
//       }
//     ),


//   downloadVisa: (application_id) =>
//     axios.get(`${API_URL}/applications/${application_id}/final-visa/download`, {
//       headers: getAuthHeader(), // Use user auth, not admin

//     }),
//   // ---------------------------------------------------------
//   // ADMIN AUTH
//   // ---------------------------------------------------------
//   adminLogin: (data) =>
//     axios.post(`${API_URL}/admin/auth/login`, data),

//   // ---------------------------------------------------------
//   // ADMIN: VISA TYPES
//   // ---------------------------------------------------------
//   adminGetVisaTypes: () =>
//     axios.get(`${API_URL}/admin/visa-types`, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminCreateVisaType: (data) =>
//     axios.post(`${API_URL}/admin/visa-types`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminUpdateVisaType: (id, data) =>
//     axios.put(`${API_URL}/admin/visa-types/${id}`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminDeleteVisaType: (id) =>
//     axios.delete(`${API_URL}/admin/visa-types/${id}`, {
//       headers: getAdminAuthHeader(),
//     }),

//   // ---------------------------------------------------------
//   // ADMIN: DOCUMENT TYPES
//   // ---------------------------------------------------------
//   adminGetDocumentTypes: () =>
//     axios.get(`${API_URL}/admin/document-types`, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminCreateDocumentType: (data) =>
//     axios.post(`${API_URL}/admin/document-types`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminUpdateDocumentType: (id, data) =>
//     axios.put(`${API_URL}/admin/document-types/${id}`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminDeleteDocumentType: (id) =>
//     axios.delete(`${API_URL}/admin/document-types/${id}`, {
//       headers: getAdminAuthHeader(),
//     }),

//   // ---------------------------------------------------------
//   // ADMIN: DOCUMENT MAPPINGS
//   // ---------------------------------------------------------
//   adminGetDocumentMappings: (visaTypeId) => {
//     const url = visaTypeId
//       ? `${API_URL}/admin/document-mappings?visa_type_id=${visaTypeId}`
//       : `${API_URL}/admin/document-mappings`;
//     return axios.get(url, {
//       headers: getAdminAuthHeader(),
//     });
//   },

//   adminCreateDocumentMapping: (data) =>
//     axios.post(`${API_URL}/admin/document-mappings`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminUpdateDocumentMapping: (id, data) =>
//     axios.put(`${API_URL}/admin/document-mappings/${id}`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminDeleteDocumentMapping: (id) =>
//     axios.delete(`${API_URL}/admin/document-mappings/${id}`, {
//       headers: getAdminAuthHeader(),
//     }),

//   // ---------------------------------------------------------
//   // ADMIN APPLICATIONS
//   // ---------------------------------------------------------
//   adminGetApplications: (params = {}) =>
//     axios.get(`${API_URL}/admin/applications`, {
//       params,
//       headers: getAdminAuthHeader(),
//     }),

//   adminGetApplication: (id) =>
//     axios.get(`${API_URL}/admin/applications/${id}`, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminUpdateApplicationStatus: (id, data) =>
//     axios.put(`${API_URL}/admin/applications/${id}/status`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminAssignApplication: (id, data) =>
//     axios.post(`${API_URL}/admin/applications/${id}/assign`, data, {
//       headers: getAdminAuthHeader(),
//     }),



//   adminUploadVisa: (application_id, formData) =>
//     axios.post(`${API_URL}/admin/applications/${application_id}/final-visa`, formData, {
//       headers: {
//         ...getAdminAuthHeader(),
//         'Content-Type': 'multipart/form-data',
//       },
//     }),



//   // ---------------------------------------------------------
//   // ADMIN USER MANAGEMENT (NEW)
//   // ---------------------------------------------------------
//   adminListUsers: () =>
//     axios.get(`${API_URL}/admin/users`, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminCreateUser: (data) =>
//     axios.post(`${API_URL}/admin/users`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminUpdateUserRole: (id, data) =>
//     axios.put(`${API_URL}/admin/users/${id}/role`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminUpdateUserStatus: (id, data) =>
//     axios.put(`${API_URL}/admin/users/${id}/status`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminDeleteUser: (id) =>
//     axios.delete(`${API_URL}/admin/users/${id}`, {
//       headers: getAdminAuthHeader(),
//     }),

//   // ---------------------------------------------------------
//   //AGENT LISTING
//   // ---------------------------------------------------------

//   adminListAgents: () =>
//     axios.get(`${API_URL}/admin/list-agents`, {
//       headers: getAdminAuthHeader(),
//     }),

//   approveAgents: (email) =>
//     axios.post(`${API_URL}/admin/approve_agent`, { email },
//       {
//         headers: getAdminAuthHeader(),
//       }
//     ),

    
//   disableAgents: (email) =>
//      axios.put(`${API_URL}/admin/users/disable`, {},
//       {
//         headers: getAdminAuthHeader(),
//         params: { email },
//       },
   
//     ),

//   sendAgentVerificationLink: (email) =>
//     axios.post(`${API_URL}/admin/users/resend-verification`, {}, {
//        headers: getAdminAuthHeader(),
//         params: { email },
//     }),

//     adminResetUserPassword: (email) =>
//     axios.post(`${API_URL}/auth/set-temporary-password`, {}, {
//        headers: getAdminAuthHeader(),
//         params: { email },
//     }),



//   // ---------------------------------------------------------
//   // ADDITIONAL INFORMATION (ADMIN + USER)
//   // ---------------------------------------------------------

//   // ========== ADMIN SIDE ==========
//   adminListAdditionalInfoRounds: (applicationId) =>
//     axios.get(`${API_URL}/admin/applications/${applicationId}/additional-info`, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminCreateAdditionalInfoRound: (applicationId, data) =>
//     axios.post(
//       `${API_URL}/admin/applications/${applicationId}/additional-info/requests`,
//       data,
//       { headers: getAdminAuthHeader() }
//     ),

//   adminGetAdditionalInfoRound: (roundId) =>
//     axios.get(`${API_URL}/admin/additional-info/${roundId}`, {
//       headers: getAdminAuthHeader(),
//     }),

//   adminSetAdditionalInfoStatus: (roundId, data) =>
//     axios.patch(
//       `${API_URL}/admin/additional-info/${roundId}/status`,
//       data,
//       { headers: getAdminAuthHeader() }
//     ),

//   // ========== USER SIDE ==========
//   userGetAdditionalInfoRounds: (applicationId) =>
//     axios.get(`${API_URL}/applications/${applicationId}/additional-info`, {
//       headers: getAuthHeader(),
//     }),

//   userSubmitAdditionalInfo: (applicationId, roundId, data) =>
//     axios.post(
//       `${API_URL}/applications/${applicationId}/additional-info/${roundId}/submit`,
//       data,
//       { headers: getAuthHeader() }
//     ),

//   adminUpdateApplication: (id, data) =>
//     axios.put(`${API_URL}/admin/applications/${id}`, data, {
//       headers: getAdminAuthHeader(),
//     }),

//   // ---------------------------------------------------------
//   // ADMIN: GET OPERATORS ONLY
//   // ---------------------------------------------------------
//   adminGetOperators: () =>
//     axios.get(`${API_URL}/admin/operators`, {
//       headers: getAdminAuthHeader(),
//     }),
// };


import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

// ----------------------------
// AXIOS INTERCEPTORS
// ----------------------------

// Response interceptor for handling token expiration
axios.interceptors.response.use(
  (response) => {
    // If response is successful, just return it
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      // Check for token expiration or invalid token
      if (
        status === 401 || 
        status === 403 || 
        data?.detail === "Invalid or expired token" ||
        data?.message === "Invalid or expired token"
      ) {
        // Determine if it's admin or user based on the request URL
        const isAdminRequest = error.config?.url?.includes('/admin/');
        
        if (isAdminRequest) {
          // Clear admin token
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminUser');
          
          // Redirect to admin login
          window.location.href = '/admin/login';
        } else {
          // Clear user token
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          
          // Redirect to user login
          window.location.href = '/login';
        }
      }
    }
    
    return Promise.reject(error);
  }
);

// Request interceptor to add token to every request (optional but recommended)
axios.interceptors.request.use(
  (config) => {
    // Check if it's an admin request
    if (config.url?.includes('/admin/')) {
      const adminToken = localStorage.getItem('adminToken');
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      }
    } else {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ----------------------------
// AUTH HELPERS
// ----------------------------
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const getAdminAuthHeader = () => {
  const token = localStorage.getItem("adminToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ----------------------------
// API EXPORTS
// ----------------------------
export const api = {
  // ---------------------------------------------------------
  // USER AUTH (Public)
  // ---------------------------------------------------------

  register: (data) => axios.post(`${API_URL}/auth/register`, data),
  login: (data) => axios.post(`${API_URL}/auth/login`, data),
  verifyEmail: (token) =>
    axios.post(`${API_URL}/auth/verify-email?token=${token}`),

  forgotPassword: (data) =>
    axios.post(`${API_URL}/auth/forgot-password`, data),
  resetPassword: (data) =>
    axios.post(`${API_URL}/auth/reset-password`, data),

  // ---------------------------------------------------------
  // USER ACCOUNT
  // ---------------------------------------------------------
  getDashboard: () =>
    axios.get(`${API_URL}/user/dashboard`, {
      headers: getAuthHeader(),
    }),

  updateProfile: (data) =>
    axios.put(`${API_URL}/user/profile`, data, {
      headers: getAuthHeader(),
    }),

  changePassword: (data) =>
    axios.post(`${API_URL}/user/change-password`, data, {
      headers: getAuthHeader(),
    }),

  // ---------------------------------------------------------
  // VISA TYPES
  // ---------------------------------------------------------
  getVisaTypes: () => axios.get(`${API_URL}/visa-types`),

  getAlldropdowns: () => axios.get(`${API_URL}/dropdowns/all`),

  getVisaTypeDocuments: (visaTypeId) =>
    axios.get(`${API_URL}/visa-types/${visaTypeId}/documents`),

  // ---------------------------------------------------------
  // USER APPLICATIONS
  // ---------------------------------------------------------
  createApplication: (data) =>
    axios.post(`${API_URL}/applications`, data, {
      headers: getAuthHeader(),
    }),

  getApplications: () =>
    axios.get(`${API_URL}/applications`, {
      headers: getAuthHeader(),
    }),

  getApplication: (id) =>
    axios.get(`${API_URL}/applications/${id}`, {
      headers: getAuthHeader(),
    }),

  updateApplication: (id, data) =>
    axios.put(`${API_URL}/applications/${id}`, data, {
      headers: getAuthHeader(),
    }),

  deleteApplication: (id) =>
    axios.delete(`${API_URL}/applications/${id}`, {
      headers: getAuthHeader(),
    }),

  // ---------------------------------------------------------
  // DOCUMENT UPLOAD
  // ---------------------------------------------------------
  uploadDocument: (formData) =>
    axios.post(`${API_URL}/documents/upload`, formData, {
      headers: {
        ...getAuthHeader(),
        "Content-Type": "multipart/form-data",
      },
    }),

  deleteDocument: (id) =>
    axios.delete(`${API_URL}/documents/${id}`, {
      headers: getAuthHeader(),
    }),

  uploadApplicationDocuments: (formData) =>
    axios.post(
      `${API_URL}/documents/bulk-upload`,
      formData,
      {
        headers: {
          ...getAuthHeader(),
          "Content-Type": "multipart/form-data",
        },
      }
    ),

  extractAndMapDocuments: (applicationId) =>
    axios.post(
      `${API_URL}/documents/extract-and-map?application_id=${applicationId}`,
      null,
      {
        headers: {
          ...getAuthHeader(),
        },
      }
    ),


  downloadVisa: (application_id) =>
    axios.get(`${API_URL}/applications/${application_id}/final-visa/download`, {
      headers: getAuthHeader(),
    }),

  // ---------------------------------------------------------
  // ADMIN AUTH
  // ---------------------------------------------------------
  adminLogin: (data) =>
    axios.post(`${API_URL}/admin/auth/login`, data),

  // ---------------------------------------------------------
  // ADMIN: VISA TYPES
  // ---------------------------------------------------------
  adminGetVisaTypes: () =>
    axios.get(`${API_URL}/admin/visa-types`, {
      headers: getAdminAuthHeader(),
    }),

  adminCreateVisaType: (data) =>
    axios.post(`${API_URL}/admin/visa-types`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminUpdateVisaType: (id, data) =>
    axios.put(`${API_URL}/admin/visa-types/${id}`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminDeleteVisaType: (id) =>
    axios.delete(`${API_URL}/admin/visa-types/${id}`, {
      headers: getAdminAuthHeader(),
    }),

  // ---------------------------------------------------------
  // ADMIN: DOCUMENT TYPES
  // ---------------------------------------------------------
  adminGetDocumentTypes: () =>
    axios.get(`${API_URL}/admin/document-types`, {
      headers: getAdminAuthHeader(),
    }),

  adminCreateDocumentType: (data) =>
    axios.post(`${API_URL}/admin/document-types`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminUpdateDocumentType: (id, data) =>
    axios.put(`${API_URL}/admin/document-types/${id}`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminDeleteDocumentType: (id) =>
    axios.delete(`${API_URL}/admin/document-types/${id}`, {
      headers: getAdminAuthHeader(),
    }),

  // ---------------------------------------------------------
  // ADMIN: DOCUMENT MAPPINGS
  // ---------------------------------------------------------
  adminGetDocumentMappings: (visaTypeId) => {
    const url = visaTypeId
      ? `${API_URL}/admin/document-mappings?visa_type_id=${visaTypeId}`
      : `${API_URL}/admin/document-mappings`;
    return axios.get(url, {
      headers: getAdminAuthHeader(),
    });
  },

  adminCreateDocumentMapping: (data) =>
    axios.post(`${API_URL}/admin/document-mappings`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminUpdateDocumentMapping: (id, data) =>
    axios.put(`${API_URL}/admin/document-mappings/${id}`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminDeleteDocumentMapping: (id) =>
    axios.delete(`${API_URL}/admin/document-mappings/${id}`, {
      headers: getAdminAuthHeader(),
    }),

  // ---------------------------------------------------------
  // ADMIN APPLICATIONS
  // ---------------------------------------------------------
  adminGetApplications: (params = {}) =>
    axios.get(`${API_URL}/admin/applications`, {
      params,
      headers: getAdminAuthHeader(),
    }),

  adminGetApplication: (id) =>
    axios.get(`${API_URL}/admin/applications/${id}`, {
      headers: getAdminAuthHeader(),
    }),

  adminUpdateApplicationStatus: (id, data) =>
    axios.put(`${API_URL}/admin/applications/${id}/status`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminAssignApplication: (id, data) =>
    axios.post(`${API_URL}/admin/applications/${id}/assign`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminUploadVisa: (application_id, formData) =>
    axios.post(`${API_URL}/admin/applications/${application_id}/final-visa`, formData, {
      headers: {
        ...getAdminAuthHeader(),
        'Content-Type': 'multipart/form-data',
      },
    }),

  // ---------------------------------------------------------
  // ADMIN USER MANAGEMENT
  // ---------------------------------------------------------
  adminListUsers: () =>
    axios.get(`${API_URL}/admin/users`, {
      headers: getAdminAuthHeader(),
    }),

  adminCreateUser: (data) =>
    axios.post(`${API_URL}/admin/users`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminUpdateUserRole: (id, data) =>
    axios.put(`${API_URL}/admin/users/${id}/role`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminUpdateUserStatus: (id, data) =>
    axios.put(`${API_URL}/admin/users/${id}/status`, data, {
      headers: getAdminAuthHeader(),
    }),

  adminDeleteUser: (id) =>
    axios.delete(`${API_URL}/admin/users/${id}`, {
      headers: getAdminAuthHeader(),
    }),

  // ---------------------------------------------------------
  //AGENT LISTING
  // ---------------------------------------------------------

  adminListAgents: () =>
    axios.get(`${API_URL}/admin/list-agents`, {
      headers: getAdminAuthHeader(),
    }),

  approveAgents: (email) =>
    axios.post(`${API_URL}/admin/approve_agent`, { email },
      {
        headers: getAdminAuthHeader(),
      }
    ),

  disableAgents: (email) =>
     axios.put(`${API_URL}/admin/users/disable`, {},
      {
        headers: getAdminAuthHeader(),
        params: { email },
      },
    ),

  sendAgentVerificationLink: (email) =>
    axios.post(`${API_URL}/admin/users/resend-verification`, {}, {
       headers: getAdminAuthHeader(),
        params: { email },
    }),

  adminResetUserPassword: (email) =>
    axios.post(`${API_URL}/auth/set-temporary-password`, {}, {
       headers: getAdminAuthHeader(),
        params: { email },
    }),

  // ---------------------------------------------------------
  // ADDITIONAL INFORMATION (ADMIN + USER)
  // ---------------------------------------------------------

  // ========== ADMIN SIDE ==========
  adminListAdditionalInfoRounds: (applicationId) =>
    axios.get(`${API_URL}/admin/applications/${applicationId}/additional-info`, {
      headers: getAdminAuthHeader(),
    }),

  adminCreateAdditionalInfoRound: (applicationId, data) =>
    axios.post(
      `${API_URL}/admin/applications/${applicationId}/additional-info/requests`,
      data,
      { headers: getAdminAuthHeader() }
    ),

  adminGetAdditionalInfoRound: (roundId) =>
    axios.get(`${API_URL}/admin/additional-info/${roundId}`, {
      headers: getAdminAuthHeader(),
    }),

  adminSetAdditionalInfoStatus: (roundId, data) =>
    axios.patch(
      `${API_URL}/admin/additional-info/${roundId}/status`,
      data,
      { headers: getAdminAuthHeader() }
    ),

  // ========== USER SIDE ==========
  userGetAdditionalInfoRounds: (applicationId) =>
    axios.get(`${API_URL}/applications/${applicationId}/additional-info`, {
      headers: getAuthHeader(),
    }),

  userSubmitAdditionalInfo: (applicationId, roundId, data) =>
    axios.post(
      `${API_URL}/applications/${applicationId}/additional-info/${roundId}/submit`,
      data,
      { headers: getAuthHeader() }
    ),

  adminUpdateApplication: (id, data) =>
    axios.put(`${API_URL}/admin/applications/${id}`, data, {
      headers: getAdminAuthHeader(),
    }),

  // ---------------------------------------------------------
  // ADMIN: GET OPERATORS ONLY
  // ---------------------------------------------------------
  adminGetOperators: () =>
    axios.get(`${API_URL}/admin/operators`, {
      headers: getAdminAuthHeader(),
    }),
};